import axios from 'axios';
import { baseURL } from '../Constants';

const categoryURL = `${baseURL}therapeuticCategory/`;

export function getCategoryList() {
  return axios
    .get(categoryURL)
    .then((response) => response)
    .catch((response) => response);
}

export function addCategory(data) {
  return axios
    .post(categoryURL, data)
    .then((response) => response)
    .catch((response) => response);
}

export function updateCategory(data) {
  return axios
    .put(`${categoryURL}${data.id}/`, data)
    .then((response) => response)
    .catch((response) => response);
}

export function deleteCategory(category) {
  return axios
    .delete(`${categoryURL}${category.id}/`, category)
    .then((response) => response)
    .catch((response) => response);
}



// WEBPACK FOOTER //
// ./src/therapeuticCategory/therapeuticCategoryApi.js